"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class to handle all review QA log xlsx 2-d array building
 */
class ReviewQALogBuilder {
    constructor(sampleRuns) {
        this._sampleRunLog = this._buildSampleRunLog(sampleRuns);
    }
    _buildSampleRunLog(sampleRuns) {
        const qaLog = [ReviewQALogBuilder._HEADERS];
        sampleRuns.forEach((sampleRun) => {
            qaLog.push([
                sampleRun.reviewerName,
                sampleRun.sampleName,
                sampleRun.sampleType,
                sampleRun.comments,
                sampleRun.date,
                sampleRun.pcrEquipmentId,
                sampleRun.experimentId,
                sampleRun.runId,
                sampleRun.run,
                sampleRun.protocolId,
                sampleRun.protocol,
                sampleRun.status,
                sampleRun.result,
                sampleRun.failureReason,
            ]);
        });
        return qaLog;
    }
    getSampleRunLog() {
        return this._sampleRunLog;
    }
}
ReviewQALogBuilder._HEADERS = [
    "Reviewed By",
    "Sample ID",
    "Sample Type",
    "Comments",
    "Date",
    "PCR Equipment ID",
    "Experiment ID",
    "Run ID",
    "Run",
    "Protocol ID",
    "Protocol",
    "Pass/Fail",
    "Result",
    "Failure Reason",
];
exports.default = ReviewQALogBuilder;
